// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pn6E","col":"styles_col__1VM5X"};